const MODE_VERB = {
  create: 'created',
  update: 'updated'
};

export function buildAmenityMediaFailureDescription(docOutcome, imgOutcome, t, mode) {
  const verbPast = MODE_VERB[mode] ?? MODE_VERB.create;
  const d = docOutcome?.status ?? 'skipped';
  const i = imgOutcome?.status ?? 'skipped';

  if ((d === 'skipped' || d === 'ok') && (i === 'skipped' || i === 'ok')) {
    return null;
  }

  const docFailed = d === 'failed';
  const imgPartial = i === 'partial';
  const imgFailed = i === 'failed';

  if (docFailed && (imgPartial || imgFailed)) {
    return t('amenity_media_doc_and_image_upload_failed', {
      defaultValue:
        'Amenity was {{verbPast}} successfully, but the PDF document and image uploads failed.',
      verbPast
    });
  }
  if (docFailed) {
    return t('amenity_media_waiver_upload_failed', {
      defaultValue:
        'Amenity was {{verbPast}} successfully, but the PDF document upload failed.',
      verbPast
    });
  }
  if (imgPartial) {
    return t('amenity_media_images_partial_fail', {
      defaultValue:
        'Amenity was {{verbPast}} successfully, but some images failed to upload.',
      verbPast
    });
  }
  if (imgFailed) {
    return t('amenity_media_images_fail', {
      defaultValue: 'Amenity was {{verbPast}} successfully, but image uploads failed.',
      verbPast
    });
  }

  return null;
}

export function buildAmenityCreateModalPayload(docOutcome, imgOutcome, t, { amenityName, buildingName }) {
  const successDescription = t('amenity_created_success_description', {
    defaultValue:
      '{{amenityName}} has been added to {{buildingName}} and is now available for resident bookings.',
    amenityName,
    buildingName
  });

  const failureDescription = buildAmenityMediaFailureDescription(
    docOutcome,
    imgOutcome,
    t,
    'create'
  );

  if (failureDescription) {
    return {
      variant: 'warning',
      title: t('Amenity Created'),
      description: failureDescription
    };
  }

  return {
    variant: 'success',
    title: t('Amenity Created'),
    description: successDescription
  };
}

export function buildAmenityUpdateMediaToast(docOutcome, imgOutcome, t) {
  const failureDescription = buildAmenityMediaFailureDescription(
    docOutcome,
    imgOutcome,
    t,
    'update'
  );

  if (failureDescription) {
    return { variant: 'warning', message: failureDescription };
  }

  return { variant: 'success', message: t('Amenity updated successfully!') };
}
